import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
// SocialHeader 컴포넌트 및 타입 임포트
import { SocialHeader } from '@edusense/shared-ui-layout';
const ListContainer = styled.div`
  border: 1px solid #e5e7eb; // gray-200
  border-radius: 8px;
  overflow: hidden;
`;
const ReviewItemContainer = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb; // gray-200

  &:last-child {
    border-bottom: none;
  }
`;
// ReviewHeader, AuthorInfo, Avatar, AuthorName 제거
// RatingStars 스타일은 유지 (Header 아래 배치)
const RatingStars = styled.div`
  margin-top: 0.75rem; // SocialHeader 아래 간격 추가
  margin-bottom: 0.75rem; // 댓글과의 간격 추가
  color: #f59e0b; // amber-500
  font-size: 1.1rem; // 별 크기 약간 키움
`;
// ReviewDate 제거 (SocialHeader가 표시)
const ReviewComment = styled.p`
  margin: 0;
  line-height: 1.6;
  color: #374151; // gray-700
  white-space: pre-wrap; // 줄바꿈 유지
`;
const LoadingPlaceholder = styled.div`
  padding: 2rem;
  text-align: center;
  color: #6b7280; // gray-500
`;
const ErrorMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #ef4444; // red-500
  background-color: #fee2e2; // red-50
  border: 1px solid #fca5a5; // red-300
  border-radius: 8px;
`;
const NoReviewsMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #6b7280; // gray-500
`;
// UserSummary를 SocialHeaderAuthor로 변환하는 헬퍼 함수
const mapReviewAuthorToSocialAuthor = (author)=>{
    return {
        id: author.id,
        name: author.displayName || '',
        username: author.username || '',
        profileImageUrl: author.profileImageUrl || undefined,
        verified: author.verified || false
    };
};
// formatDate 헬퍼 함수 제거 (SocialHeader가 자체적으로 처리)
const ReviewList = ({ reviews = [], isLoading = false, error = null })=>{
    if (isLoading) {
        return /*#__PURE__*/ _jsx(LoadingPlaceholder, {
            children: "리뷰를 불러오는 중..."
        });
    }
    if (error) {
        return /*#__PURE__*/ _jsxs(ErrorMessage, {
            children: [
                "오류가 발생했습니다: ",
                error
            ]
        });
    }
    if (reviews.length === 0) {
        return /*#__PURE__*/ _jsx(NoReviewsMessage, {
            children: "아직 작성된 리뷰가 없습니다."
        });
    }
    return /*#__PURE__*/ _jsx(ListContainer, {
        children: reviews.map((review)=>/*#__PURE__*/ _jsxs(ReviewItemContainer, {
                children: [
                    /*#__PURE__*/ _jsx(SocialHeader, {
                        author: mapReviewAuthorToSocialAuthor(review.author),
                        createdAt: new Date(review.createdAt),
                        size: "sm" // 작은 사이즈 사용
                        ,
                        showTimestamp: true,
                        showActions: false,
                        variant: "default"
                    }),
                    /*#__PURE__*/ _jsxs(RatingStars, {
                        title: `평점 ${review.rating}점`,
                        children: [
                            '★'.repeat(review.rating),
                            '☆'.repeat(5 - review.rating)
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ReviewComment, {
                        children: review.comment
                    })
                ]
            }, review.id))
    });
};
export default ReviewList;
